const playerSaveImagePreview = enabled => {};
window.playerSaveImagePreview = playerSaveImagePreview;

const playerSaveAutoplay = enabled => {};
window.playerSaveAutoplay = playerSaveAutoplay;
